import baseUrl from '../baseUrl';
const { path } = baseUrl.path(); 

// 用户组织、角色管理
export default {
  get_current_organ_tree: path + '/uc/organ/getCurrentOrganDeptTree', //获取当前登录的单位部门树
  delete_uc_dept: path + '/uc/dept', //删除部门
  get_page_staff: path + '/uc/staff/pageStaff', //员工分页列表
  post_add_dept: path + '/uc/dept', //添加部门
  put_update_dept: path + '/uc/dept', // 更新部门
  post_add_staff: path + '/uc/staff', //添加员工
  put_update_staff: path + '/uc/staff', //更新员工
  delete_uc_staff: path + '/uc/staff', //删除人员
  post_batch_delete_staff: path + '/uc/staff/batchDeleteStaff', //批量删除员工
  put_set_dept_manager: path + '/uc/role/setDeptManager', //设置部门管理员
  put_cancel_dept_manager: path + '/uc/role/cancelDeptManager',//取消部门管理员
  
  get_related_organ_tree: path + '/uc/organ/getRelatedOrganDeptTree', //获取关联单位的单位部门树
  get_cancel_organ_related: path + '/uc/organ/cancelOrganRelated', //取消单位关联

  post_distribute_app: path + '/uc/application/distributeApplicationsToRelatedOrgan', //分配应用
  get_related_app: path + '/uc/application/listRelatedOrganApplication', //关联单位分配的应用
  get_app_list: path + '/uc/application/listCurrentOrganApplication', //登录员工应用列表
  post_create_related_organ: path + '/uc/organ/createRelatedOrgan', //创建关联组织
  get_uc_organ_data: path + '/uc/organ/', //组织详细信息
  put_update_uc_organ: path + '/uc/organ', //更新单位信息
  get_staff_role: path + '/uc/role/listStaffRole', //当前员工角色
  get_related_staff_role: path + '/uc/role/listRelatedOrganStaffRole',//列出关联单位角色

  get_duty_list:path + '/uc/duty/list', //岗位列表
  post_add_duty: path + '/uc/duty', //添加岗位
  put_update_duty: path + '/uc/duty', //更新岗位
  delete_uc_duty: path + '/uc/duty', // 删除岗位

  get_work_bench_tree: path + '/uc/organ/getWorkbenchOrganDeptTree', //获取工作台组织架构
  get_work_bench_staff: path + '/uc/staff/listWorkbenchStaff', //工作台员工列表
  post_batch_add_staff: path + '/uc/staff/batchAddStaff', // 批量添加员工

  get_organ_detail: path + '/uc/organ/detail/', //获取单位名称
  get_organ_info: path + '/uc/organ', // 组织详细信息
  get_organ_related_status: path + '/uc/organ/organRelatedStatus', //是否关联
  get_accept_related: path + '/uc/organ/acceptOrganRelated', //接受组织关联
  get_depart_staff: path + '/uc/staff/list' , // 查询员工列表（根据部门）

  // 角色权限管理
  get_app_organ_list: path + '/uc/organ/listApplicationOrgan', //查询应用关联单位列表
  get_app_role_list: path + '/uc/role/listApplicationRole', //查询应用下角色列表
  delete_app_role: path + '/uc/role', //删除角色
  post_add_app_role: path + '/uc/role', //添加角色
  put_update_app_role: path + '/uc/role', //更新角色
  get_organ_resource_tree: path + '/uc/resource/getOrganApplicationResourceTree', //获取单位应用下的菜单树
  get_role_resource: path + '/uc/resource/getRoleResourceIds', //获取角色关联的菜单资源id
  get_role_app_staff: path + '/uc/staff/listApplicationRoleStaff', //列出应用角色下的员工
  
};
